<form name="formApproveReject">
    <div class="row">
        <div class="col-md-12">{{ "DATASET_DIALOG.CHOOSE" | translate }}</div>
    </div>
    <div class="row">
        <div class="col-md-12">&nbsp;</div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label>
                <input type="radio" [(ngModel)]="approveAction" value="approve" name="approveAction" (ngModelChange)="onApproveActionChanged()" />
                {{ "DATASET_DIALOG.LABEL.OKAY" | translate }}
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label>
                <input type="radio" [(ngModel)]="approveAction" value="reject" name="approveAction" (ngModelChange)="onApproveActionChanged()" />
                {{ "DATASET_DIALOG.LABEL.NOT_OKAY" | translate }}
            </label>
        </div>
    </div>
    <div class="row">
        @if (approveAction === "approve") {
            <div class="col-md-12 mb-2">{{ "DATASET_DIALOG.PRO.OKAY.TEXT" | translate }}</div>
        }
        @if (approveAction === "reject") {
            <div class="col-md-12 mb-2">{{ "DATASET_DIALOG.PRO.NOT_OKAY.TEXT" | translate }}</div>
        }
        <div class="col-md-12">
            <textarea class="form-control" id="rejectcomment" [(ngModel)]="dataset.approvedNote" name="approvedNote" (ngModelChange)="onApprovedNoteChanged()"></textarea>
            <br />
            @if (approveAction === "reject" && feedbackRequired) {
                <div class="alert alert-danger">{{ "DATASET_DIALOG.PRO.NOT_OKAY.COMMENT" | translate }}</div>
            }
        </div>
    </div>
</form>
